import React from 'react';
import { FaArrowLeft, FaShieldAlt } from 'react-icons/fa';

export default function AvisoPrivacidad() {
  return (
    <div className="min-h-screen bg-slate-900 text-white">

      <div className="w-full px-6 py-4 flex items-center border-b border-white/10">
        <a href="/" className="flex items-center gap-2 text-white hover:text-blue-400 font-medium">
          <FaArrowLeft /> Inicio
        </a>
      </div>

      <div className="max-w-3xl mx-auto px-4 py-10">

        <div className="flex items-center gap-3 mb-8">
          <FaShieldAlt className="text-blue-400 text-3xl" />
          <div>
            <h1 className="text-2xl font-black">Aviso de Privacidad</h1>
            <p className="text-slate-400 text-sm">Transportes Ángeles del Puerto</p>
          </div>
        </div>

        <div className="space-y-8 text-slate-300 text-sm leading-relaxed">

          <section>
            <h2 className="text-white font-bold text-base uppercase mb-2">1. Responsable del tratamiento</h2>
            <p>
              <strong className="text-white">Transportes Ángeles del Puerto</strong>, con domicilio en
              Galeana 522, Centro, C.P. 68000, Oaxaca de Juárez, Oaxaca, México,
              es responsable del tratamiento de sus datos personales conforme a la
              Ley Federal de Protección de Datos Personales en Posesión de los
              Particulares (LFPDPPP) y su Reglamento.
            </p>
            <p className="mt-2">
              Contacto para privacidad:{' '}
              <a href="tel:+529546777156" className="text-blue-400 underline">954 167 7156</a>
            </p>
          </section>

          <section>
            <h2 className="text-white font-bold text-base uppercase mb-2">2. Datos personales que recabamos</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Nombre completo del pasajero o pasajeros</li>
              <li>Número de teléfono de contacto</li>
              <li>Fecha y hora de viaje seleccionados</li>
              <li>Número de asiento(s) reservado(s)</li>
            </ul>
            <p className="mt-3 text-slate-400">
              <strong className="text-white">No recabamos</strong> datos sensibles como
              datos bancarios (el pago con tarjeta lo procesa Stripe directamente; nosotros
              nunca vemos ni almacenamos información de tu tarjeta).
            </p>
          </section>

          <section>
            <h2 className="text-white font-bold text-base uppercase mb-2">3. Finalidades del tratamiento</h2>
            <p className="font-bold text-white mb-1">Finalidades primarias (necesarias para el servicio):</p>
            <ul className="list-disc pl-5 space-y-1 mb-3">
              <li>Emitir y enviar tu boleto de viaje digital</li>
              <li>Verificar tu identidad al abordar la unidad</li>
              <li>Gestionar cambios, cancelaciones o reembolsos</li>
              <li>Contactarte en caso de modificaciones al viaje</li>
              <li>Cumplir obligaciones legales ante autoridades de transporte</li>
            </ul>
            <p className="font-bold text-white mb-1">Finalidades secundarias (puedes oponerte):</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Informarte sobre promociones o descuentos futuros</li>
            </ul>
          </section>

          <section>
            <h2 className="text-white font-bold text-base uppercase mb-2">4. Transferencia de datos</h2>
            <p>
              Tus datos son compartidos únicamente con los siguientes terceros necesarios para prestarte el servicio,
              quienes están obligados a mantenerlos confidenciales:
            </p>
            <ul className="list-disc pl-5 space-y-1 mt-2">
              <li><strong className="text-white">Stripe, Inc.</strong> — procesador de pagos (solo recibe el monto y la referencia de la transacción).</li>
              <li><strong className="text-white">Google LLC</strong> — infraestructura de base de datos (Firebase/Firestore) y Analytics.</li>
            </ul>
            <p className="mt-2">
              No vendemos, cedemos ni transferimos tus datos a terceros con fines comerciales.
            </p>
          </section>

          <section>
            <h2 className="text-white font-bold text-base uppercase mb-2">5. Derechos ARCO</h2>
            <p>
              Tienes derecho a <strong className="text-white">Acceder</strong> a tus datos,
              <strong className="text-white"> Rectificarlos</strong> si son incorrectos,
              <strong className="text-white"> Cancelarlos</strong> o
              <strong className="text-white"> Oponerte</strong> a su uso (derechos ARCO).
            </p>
            <p className="mt-2">
              Para ejercerlos envía una solicitud a nuestro número de contacto:
            </p>
            <div className="mt-3 bg-slate-800 rounded-xl p-4 inline-block">
              <p className="font-bold text-white">📞 954 167 7156</p>
              <p className="text-slate-400 text-xs mt-1">Indicando: nombre completo, teléfono registrado y derecho que deseas ejercer.</p>
            </div>
            <p className="mt-3">
              Tendremos un plazo de <strong className="text-white">20 días hábiles</strong> para responder a tu solicitud.
            </p>
          </section>

          <section>
            <h2 className="text-white font-bold text-base uppercase mb-2">6. Cookies y tecnologías de rastreo</h2>
            <p>
              Este sitio utiliza cookies técnicas necesarias para su funcionamiento y cookies de
              analítica (Google Analytics) para medir el tráfico de forma anónima. No utilizamos
              cookies de publicidad de terceros.
            </p>
          </section>

          <section>
            <h2 className="text-white font-bold text-base uppercase mb-2">7. Cambios al aviso</h2>
            <p>
              Cualquier modificación a este Aviso de Privacidad será publicada en esta misma página.
              Te recomendamos consultarla periódicamente.
            </p>
            <p className="mt-2 text-slate-400">Última actualización: junio 2026.</p>
          </section>

          <section className="bg-blue-500/10 border border-blue-500/30 rounded-2xl p-5">
            <p className="text-xs text-slate-400">
              Este aviso se emite en cumplimiento del artículo 15 de la Ley Federal de Protección de
              Datos Personales en Posesión de los Particulares (LFPDPPP) y los Lineamientos del Aviso
              de Privacidad emitidos por el INAI.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
}
